import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconElectrocardiogram: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="electrocardiogram, activity, notification, pulse, heartbeat, beat"><path d="M1.75 11.75H6L9 3.5L15 20.75L18 11.75H22.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconElectrocardiogram;
